export const PARTNER_MENU_ITEMS = [
    { path: "/partner/operation/company", label: "관리 사업자", groupKey: "basic-info" },
    { path: "/partner/members", label: "구성원", groupKey: "basic-info" },
    { path: "/partner/operation/warehouse", label: "창고", groupKey: "basic-info" },
    { path: "/partner/operation/custom-equipment-model", label: "사용자 정의 모델", groupKey: "basic-info" },
    { path: "/partner/operation/consumables", label: "부소모품 코드", groupKey: "basic-info" },
    { path: "/partner/customer", label: "고객", groupKey: "basic-info" },
    { path: "/partner/resource/equipment", label: "복합기·프린터 현황", groupKey: "assets" },
    { path: "/partner/resource/consumables", label: "부소모품 입출고", groupKey: "assets" },
    { path: "/partner/resource/consumable-inventory", label: "부소모품 재고", groupKey: "assets" },
    { path: "/partner/printer", label: "복합기·프린터 관리", groupKey: "collected-equipment" },
    { path: "/partner/printer/unregistered", label: "메일수집장비 등록", groupKey: "collected-equipment" },
    { path: "/partner/printer/agents", label: "고객 미할당 에이전트", groupKey: "collected-equipment" },
    { path: "/partner/monitoring/data/usage", label: "사용량", groupKey: "monitoring" },
    { path: "/partner/monitoring/data/supplies", label: "소모품", groupKey: "monitoring" },
    { path: "/partner/monitoring/customer", label: "고객현황", groupKey: "monitoring" },
    { path: "/partner/as/register", label: "접수", groupKey: "as" },
    { path: "/partner/as/progress", label: "진행", groupKey: "as" },
    { path: "/partner/as/completed", label: "완료", groupKey: "as" },
    { path: "/partner/as/consumable-usages", label: "부소모품 사용 현황", groupKey: "as" },
    { path: "/partner/contract/uncontracted-equipment", label: "미계약 장비", groupKey: "contract" },
    { path: "/partner/contract/list", label: "계약 목록", groupKey: "contract" },
    { path: "/partner/contract/invoice", label: "계약 명세서 발행", groupKey: "contract" },
    { path: "/partner/contract/invoice/issued", label: "계약 명세서 완료", groupKey: "contract" },
    { path: "/partner/contract/sales", label: "판매/용역서비스 등록", groupKey: "contract" },
    { path: "/partner/contract/sales/issued", label: "판매/용역서비스 완료", groupKey: "contract" },
    { path: "/partner/sales-evidence/tax-invoice", label: "세금계산서", groupKey: "sales-evidence" },
    { path: "/partner/payment/cash-receipt", label: "현금영수증", groupKey: "sales-evidence" },
    { path: "/partner/sales-evidence/completed", label: "증빙 완료", groupKey: "sales-evidence" },
    { path: "/partner/payment/account-lookup", label: "계좌 입출금", groupKey: "payment" },
    { path: "/partner/payment/cms-member", label: "CMS 회원 관리", groupKey: "payment" },
    { path: "/partner/payment/cms-withdrawal", label: "CMS 출금", groupKey: "payment" },
    { path: "/partner/ledger/transaction", label: "거래 원장", groupKey: "ledger" },
    { path: "/partner/ledger/advance-payment", label: "선수금 원장", groupKey: "ledger" },
    { path: "/partner/penalty/billing", label: "위약금 청구", groupKey: "task-mgmt" },
    { path: "/partner/report/sales", label: "보고서", groupKey: "task-mgmt" },
    { path: "/partner/report/customer-monthly-sales", label: "보고서", groupKey: "task-mgmt" },
    { path: "/partner/report/sales-vs-consumable-cost", label: "보고서", groupKey: "task-mgmt" },
    { path: "/partner/report/customer-count", label: "보고서", groupKey: "task-mgmt" },
    { path: "/partner/report/equipment-count", label: "보고서", groupKey: "task-mgmt" },
    { path: "/partner/report/usage", label: "보고서", groupKey: "task-mgmt" },
    { path: "/partner/report/as-consumable-cost", label: "보고서", groupKey: "task-mgmt" },
    { path: "/partner/report/as-type", label: "보고서", groupKey: "task-mgmt" },
    { path: "/partner/report/engineer", label: "보고서", groupKey: "task-mgmt" },
];

export const PARTNER_MENU_BY_PATH = new Map(PARTNER_MENU_ITEMS.map((item) => [item.path, item]));
